import { BlockStack, Box, Divider } from '@shopify/polaris';
import { WidgetDesignTexts } from './component/WidgetDesignText';
import { WidgetFontSize } from './component/WidgetFontSize';
import { WidgetTextCommon } from './component/WidgetTextCommon';
import { WidgetTextFields } from './component/WidgetTextFields';

export const WidgetDesignTextField = () => {
  return (
    <BlockStack gap={'300'}>
      <WidgetFontSize />
      <Divider borderColor="border" />
      <Box padding={'300'} paddingBlock={'0'}>
        <WidgetTextFields />
      </Box>
      <Divider borderColor="border" />
      <Box padding={'300'} paddingBlock={'0'}>
        <WidgetTextCommon />
      </Box>
      <Divider borderColor="border" />
      <Box padding={'300'} paddingBlockStart={'0'}>
        <WidgetDesignTexts />
      </Box>
    </BlockStack>
  );
};
